import React, { useEffect, useState, useRef } from "react";
import { useOutletContext, useLocation, useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Image,
  Flex,
  Divider,
  Alert,
  Button,
  Layout,
  Skeleton,
} from "antd";
import { ExpandOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import history from "history/browser";
import { setCookies, getAccessToken } from "../../../../../../../../utils";
import moment from "moment";
// import { useCookies } from 'react-cookie';
import { WebSocketURL } from "../../../../../../../../config/config";
import { useDispatch, useSelector } from "react-redux";
import BGAttendance from "../../../../../../../../assets/images/png/feature/attendance/BG-Attendance.png";
import QRCodeDummy from "../../../../../../../../assets/images/png/feature/attendance/QR-CODE.png";
import ic_check from "../../../../../../../../assets/images/png/feature/attendance/ic_check.png";
import loader from "../../../../../../../../assets/images/svgs/ic_loader_lazyload.svg";

import ModalQuitScorm from "../../../../../../../../components/ModalQuitScorm";
import useActions from "./hooks/useActions";
import { Loader as LoadingSCROM } from "../../../../../../../../components/Loader";
// for translate
import { useTranslation } from "react-i18next";

// import styles
import styles from "./styles";
import { current } from "@reduxjs/toolkit";
import {
  getListModule,
  getListModuleSupport,
  completionModule,
  checkHasRatingModule,
  checkGotBadges,
  claimPoint,
} from "../../../../../../../../api/repositories";
// let socket;

import { encryptData, decryptData, setLocalStorage, getLocalStorage } from "../../../../../../../../utils";

import { setIsPlay, setBackLoad } from "../../../../../../../../redux/features/learning_journey/learningJourneySlice";

import { baseUrlOrigin } from "../../../../../../../../config/config";

// import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

const StreamSCORM = ({ isMobileVersion }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const socketRef = useRef(null);
  const reconnectIntervalRef = useRef(null);
  const iframeRef = useRef(null);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const userId = useSelector((state) => state.localization.userId);
  const isPlay = useSelector((state) => state.learning_journey.isPlay);

  const [outletProps] = useOutletContext();
  const [openModalQuit, setModalQuit] = useState(false);
  const [confirmNavigate, setConfirmNavigate] = useState(false);
  const [listCourseBlocker, setListCourseBlocker] = useState(false);
  const [courseIdClicked, setCourseIdClicked] = useState(0);
  const [singleCall, setSingleCall] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [lastModuleInScormPage, setLastModuleInScormPage] = useState(null);
  const [lastModuleSupportInScormPage, setLastModuleSupportInScormPage] =
    useState(null);
  const [loadingCheckCompleteModule, setLoadingCheckCompleteModule] =
    useState(false);
  const [finishModule, setFinishModule] = useState(false);
  const [iframeOnload, setiframeOnload] = useState(true)
  const [ backTrigger, setBackTrigger ] = useState(false);

  const {
    loadingLP,
    journeyId,
    courseId,
    moduleId,
    setModuleStream,
    setIdxOpenedModule,
    hiddenClick,
    setHiddenClick,
    setLinkStream,
    moduleStream,
    idxOpenedModule,
    linkStream,
    mainState,
    setCheckModalQuit,
    setRefetchLeftSection,
    setRefreshListModule,
  } = outletProps;

  const {
    idx,
    currModuleStream,
    currModuleLink,
    loadingFetchStream,
    setCurrModuleLink,
    loadingFetchQR,
    imgQRCodeAttd,
    learnerNameAttd,
    classAttd,
    isModuleAttd,
    dataWS,
    setDataWS,
    dataCompleteAttendance,
    sendScormData,
    loadingGetScorm,
    dataGetScorm,
    loadingSendScorm
  } = useActions(
    moduleStream,
    loadingLP,
    journeyId,
    courseId,
    moduleId,
    setModuleStream,
    setIdxOpenedModule,
    hiddenClick,
    setHiddenClick,
    setLinkStream,
    setRefreshListModule,
    isMobileVersion,
    mainState,
    finishModule,
  );

  var location = useLocation();
  var navigate = useNavigate();

  const url = window.location.pathname;
  const arrId = url.split("/");
  const journeyIdPosition = arrId.indexOf("journey");
  const courseIdPosition = arrId.indexOf("course");
  const moduleIdPosition = arrId.indexOf("module");
  const moduleSupIdPosition = arrId.indexOf("supporting");
  const currentJourneyId = parseInt(arrId[journeyIdPosition + 1]);
  const currentCourseId = parseInt(arrId[courseIdPosition + 1]);
  const currentModuleId = parseInt(arrId[moduleIdPosition + 1]);
  const currentModuleSupId = parseInt(arrId[moduleSupIdPosition + 1]);

  // const screens = useBreakpoint();
  // const isMobileVersion = screens.xs;

  // const [cookies, setCookie, removeCookie] = useCookies([]);
  // useEffect(() => {
  //     // setCookie('MoodleSessionasd', 'abcde', {path:'/'})
  //     setTimeout(() => {
  //         // removeCookie('MoodleSession')

  //         const cookies = document.cookie.split(";");

  //         for (let i = 0; i < cookies.length; i++) {
  //             const cookie = cookies[i];
  //             const eqPos = cookie.indexOf("=");
  //             const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
  //             document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  //         }
  //     }, 3000);
  // },[])

  useEffect(() => {
    if (isMobileVersion && finishModule) {
      setFinishModule(true);
    }

    return () => {
      setFinishModule(false);
    };
  }, [finishModule]);

  const navigateUrlCourse = (url) => {
    // block url if on Stream Scorm Page
    history.replace(url);
    setListCourseBlocker(true);
  };

  const createBlocker = () => {
    document.querySelectorAll(".ant-collapse-item").forEach((e, idx) => {
      e.style.position = "relative";
      const getIdCourse = e.getAttribute("id");
      const getIdJourney = e.getAttribute("journey_id");

      const collapseHeader = e.querySelector(".ant-collapse-header");
      const a = document.createElement("a");

      a.classList.add("course-blocker");

      a.setAttribute("courseidblocker", getIdCourse);
      a.setAttribute("journeyidblocker", getIdJourney);
      a.style.width = "100%";
      a.style.height = collapseHeader.offsetHeight - 2 + "px";
      a.style.position = "absolute";
      a.style.top = "0";
      a.style.zIndex = "15";
      e.appendChild(a);
      a.onclick = function () {
        // get clicked course id when current a-blocker clicked
        setCourseIdClicked(getIdCourse);

        if (isMobileVersion) {
          // this navigate is for formality
          navigateUrlCourse(
            `/my-learning-journey/journey/${getIdJourney}/course/${getIdCourse}`,
          );
        } else {
          // this navigate is for formality
          navigateUrlCourse(
            `/my-learning-journey/journey/${getIdJourney}/course/${getIdCourse}`,
          );
        }
      };
    });
    document.querySelectorAll(".ant-collapse-header").forEach((e, idx) => {
      e.style.zIndex = "10";
    });
  };

  const initClickCourse = () => {
    // click targeted List Course collapsed
    document
      .querySelectorAll("#dropdown-list-course-program")
      .forEach((e, idx) => {
        if (e.getAttribute("data-id") === courseIdClicked) {
          e.click();
        }
      });
  };

  const fetchSupportingModule = async (currentJourneyId, currentCourseId) => {
    try {
      const { data, status } = await getListModuleSupport(
        currentJourneyId,
        currentCourseId,
      );
      // dispatch(setInvalidToken(status));
      // mainState.setLastModuleSupport(data);
      setLastModuleSupportInScormPage(data);
    } catch (err) {
      // mainState.setLastModuleSupport(null);
      setLastModuleSupportInScormPage(null);
      setLoadingCheckCompleteModule(false);
    } finally {
      setLoadingCheckCompleteModule(false);
      setDataWS(undefined);
      setSuccessPopup(false);
      mainState.setIsFetchRating(true);
      mainState.setCurrModuleExit(moduleStream);
      mainState.setCompletion(true);
      mainState.setModuleTargetedComplete(moduleStream);
      setSingleCall(true);
      setModalQuit(false);
      setCheckModalQuit(true);
      setConfirmNavigate(true);
      mainState.setPopupStream((prevState) => {
        return {
          ...prevState,
          status: false,
        };
      });
      setFinishModule(true);
    }
  };

  const fetchDetailCourse = async () => {
    setLoadingCheckCompleteModule(true);

    try {
      const { data, status } = await getListModule(
        currentJourneyId,
        currentCourseId,
      );
      // dispatch(setInvalidToken(status));
      setLastModuleInScormPage(data);
    } catch (err) {
      // mainState.setLastModule(null);
      setLastModuleInScormPage(null);
      setLoadingCheckCompleteModule(false);
    } finally {
      fetchSupportingModule(currentJourneyId, currentCourseId);
    }
  };

  useEffect(() => {
    lastModuleInScormPage && mainState.setLastModule(lastModuleInScormPage);
    lastModuleSupportInScormPage &&
      mainState.setLastModuleSupport(lastModuleSupportInScormPage);
  }, [lastModuleInScormPage, lastModuleSupportInScormPage]);

  // console.log("lastModuleInScormPage", lastModuleInScormPage);
  // console.log("lastModuleSupportInScormPage", lastModuleSupportInScormPage);

  const handleExit = () => {
    dispatch(setIsPlay(false))
    sessionStorage.removeItem("data-get-scorm");
    if (isMobileVersion) {
      // use timeout to sync with clearDataForm(scormLocalStorageKey) on stream scorm
      setTimeout(() => {
        fetchDetailCourse();
      }, 800);
    } else {
      setiframeOnload(true)
      setDataWS(undefined);
      setSuccessPopup(false);
      mainState.setIsFetchRating(true);
      mainState.setCurrModuleExit(moduleStream);
      setLinkStream("");
      setCurrModuleLink("");
      mainState.setCompletion(true);
      mainState.setModuleTargetedComplete(moduleStream);
      setSingleCall(true);
      setCheckModalQuit(false);
      setConfirmNavigate(true);

      let urlTarget = window.location.pathname.replace(/\/play$/, "");
      if(backTrigger) {
        dispatch(setBackLoad(true));
      } else {
        dispatch(setBackLoad(false));
      }
      mainState.setPopupStream((prevState) => {
        return {
          ...prevState,
          status: false,
          url: backTrigger ? urlTarget : prevState.url,
        };
      });

      mainState.setRefetchJourney(true); // trigger refetch list journey after play module
      // console.log("set mainState");

      const courseBlocker = document.querySelectorAll(".course-blocker");
      if (courseBlocker.length > 0) {
        // delete all blocker
        document.querySelectorAll(".course-blocker").forEach((e) => e.remove());

        // if courseIdClicked not 0 then user click list course
        if (courseIdClicked !== 0) initClickCourse();
      }
    }
  };

  const handleDataScormSend = (arrIdAll) => {
    // console.log(decryptData(getLocalStorage("scorm-"+arrIdAll[7])))
    const getFromLocalStorage = getLocalStorage("scorm-"+arrIdAll[7])
    if (Array.isArray(getFromLocalStorage) && getFromLocalStorage.length === 0) {
      sendScormData([], "scorm-"+arrIdAll[7])

      // give toast snackbar
      mainState.setMessageSnack("Received invalid or corrupted data. Please contact customer support for assistance.");
      mainState.setOpenedSnack(true);
    } else {
      // data from modul id in url
      const rawDataDecrypt = decryptData(getLocalStorage("scorm-"+arrIdAll[7]))  
      console.log(rawDataDecrypt)
      
      sendScormData(rawDataDecrypt, "scorm-"+arrIdAll[7]);
    }
    
  }

  const handleFullscreen = () => {
    const boxIframe =
      isModuleAttd !== undefined && isModuleAttd === 1
        ? document.getElementById("attendance-wrapper")
        : document.getElementById("scorm-player");

    if (boxIframe.requestFullscreen) {
      boxIframe.requestFullscreen();
    } else if (boxIframe.webkitRequestFullscreen) {
      /* Safari */
      boxIframe.webkitRequestFullscreen();
    } else if (boxIframe.msRequestFullscreen) {
      /* IE11 */
      boxIframe.msRequestFullscreen();
    }
  };

  const handleNo = () => {
    setBackTrigger(false);
    setModalQuit(false);
    setCheckModalQuit(false);
    setConfirmNavigate(false);
    setListCourseBlocker(false);
    setCourseIdClicked(0);
    
    const urlNow = window.location.pathname;
    const arrIdAll = urlNow.split("/");

    localStorage.removeItem("scorm-"+arrIdAll[7]);
  };

  // shoModal always fired after unblock route
  const showModal = () => {
    setModalQuit(true);

    // --- method for prevent setCheckModalQuit always got true ---
    const url = window.location.pathname;
    const arrId = url.split("/");
    const playIndex = arrId.indexOf("play");

    if (playIndex === arrId.length - 1) {
      setCheckModalQuit(true);
      requestData()
    } else {
      setCheckModalQuit(false);
    }
    // --- method for prevent setCheckModalQuit always got true ---

    if (confirmNavigate === false) return false;
    return true;
  };

  useEffect(() => {
    if (
      confirmNavigate === true &&
      listCourseBlocker === false &&
      singleCall === true
    ) {
      // navigate(mainState.popupStream.url)
      mainState.setTrigerExitModule(true);
      mainState.setCurrModuleExit(moduleStream);

      // state from Learning Pages to reFetch Left Section of Learning Pages
      setRefetchLeftSection(true);
      setSingleCall(false);
      mainState.setCompletion(true);
      mainState.setModuleTargetedComplete(moduleStream);
    }
    if (!isMobileVersion) {
      let unblock = history.block((tx) => {
        // Navigation was blocked! Let's show a confirmation dialog

        let url = tx.location.pathname;
        if (showModal()) {
          // Unblock the navigation.
          unblock();

          // Retry the transition.
          tx.retry();
        }
      });
    }
  }, [mainState]);

  useEffect(() => {
    // document.cookie = `referral_key=hello;max-age=604800;domain=example.com`
    mainState.setPopupStream((prevState) => {
      return {
        ...prevState,
        status: true,
      };
    });

    if(!isPlay){
      let newPath = window.location.pathname.replace(/\/play$/, "");
      handleExit();
      navigate(newPath);
    }
  }, []);

  useEffect(() => {
    if (moduleStream !== undefined && !isMobileVersion) createBlocker();
  }, [moduleStream]);

  const convertMessageWebSockettoJSON = (value) => {
    const jsonparse = JSON.parse(value);

    setDataWS(JSON.parse(jsonparse));
  };

  const connectWebSocket = () => {
    // Membuka koneksi WebSocket
    socketRef.current = new WebSocket(WebSocketURL);

    // Event: saat koneksi terbuka
    socketRef.current.onopen = () => {
      // console.log("WebSocket Connected");
      clearInterval(reconnectIntervalRef.current); // Hentikan usaha reconnect
    };

    // Event: saat menerima pesan
    socketRef.current.onmessage = (event) => {
      // console.log(event.data);
      convertMessageWebSockettoJSON(event.data);
      setMessages((prevMessages) => [...prevMessages, event.data]);
    };

    // Event: saat koneksi ditutup
    socketRef.current.onclose = () => {
      // console.log("Websocket Disconnected.");
      //   console.log("WebSocket Disconnected. Attempting to reconnect...");
      //   attemptReconnect();
    };

    // Event: saat terjadi error
    socketRef.current.onerror = (error) => {
      // console.error("WebSocket Error:", error);
      socketRef.current.close();
    };
  };

  const attemptReconnect = () => {
    if (!reconnectIntervalRef.current) {
      reconnectIntervalRef.current = setInterval(() => {
        // console.log("Trying to reconnect...");
        connectWebSocket();
      }, 3000); // Coba reconnect setiap 3 detik
    }
  };

  const sendMessage = () => {
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      const dataSend = {
        type: "web",
        userId: parseInt(userId),
      };
      socketRef.current.send(JSON.stringify(dataSend));
      setInput("");
    } else {
      console.log("WebSocket is not connected.");
    }
  };

  const checkCompleteCheckin = () => {
    const dataFetchCompleteAttd = dataCompleteAttendance;
    const dateNow = new Date();
    // console.log(dateNow);
  };

  useEffect(() => {
    if (
      dataCompleteAttendance !== undefined &&
      dataCompleteAttendance !== null
    ) {
      const dataFetchCompleteAttd = dataCompleteAttendance;
      const iscurrentDate = moment(dataFetchCompleteAttd.date).isSame(
        new Date(),
        "day",
      );

      if (moduleStream.is_complete === 1 || iscurrentDate === true) {
        setSuccessPopup(true);
      } else {
        setSuccessPopup(false);
      }
    }
  }, [dataCompleteAttendance]);

  useEffect(() => {
    if (isModuleAttd !== undefined && isModuleAttd === 1) {
      connectWebSocket();

      setTimeout(() => {
        sendMessage();
      }, 3000);
    }

    // Cleanup saat komponen dilepas
    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
      clearInterval(reconnectIntervalRef.current);
    };
  }, [isModuleAttd]);

  const sendMessageFrame = () => {
    const iframe = document.getElementById("scorm-player");
    const iframeMobile = document.getElementById("scorm-player-mobile");
    const message = { token: getAccessToken().toString() };

    // Kirim pesan ke iframe (pastikan origin sesuai jika di domain berbeda)
    if (isMobileVersion) {
      iframeMobile.contentWindow.postMessage(message, "*");
    } else {
      iframe.contentWindow.postMessage(message, "*");
    }
  };

  useEffect(() => {
    if (loadingFetchStream === false && isModuleAttd === undefined) {
      setTimeout(() => {
        // console.log("calling sendmessage");
        sendMessageFrame();
      }, 500);
    }
  }, [loadingFetchStream]);

  const handleIframeLoad = () => {
    // Panggil fungsi setelah iframe selesai load
    setiframeOnload(false)
  };

  // Fungsi untuk minta data ke iframe
  const requestData = () => {
    const urlNow = window.location.pathname;
    const arrIdNow = urlNow.split("/");

    const iframe = document.getElementById(isMobileVersion?"scorm-player-mobile":"scorm-player");
    iframe.contentWindow.postMessage(
      { type: "GET_LOCALSTORAGE", key: "data_scorm_web"},
      baseUrlOrigin
    );
  };

  // fungsi untuk ngirim module id untuk diset ke data_scorm-moduleid di iframe module child
  const sendModuleIdtoIframe = (payload = null) => {
    const urlNow = window.location.pathname;
    const arrIdNow = urlNow.split("/");

    const iframe = document.getElementById(
      isMobileVersion ? "scorm-player-mobile" : "scorm-player"
    );

    const payloadModuleIdandUserid = "data_scorm_web"

    iframe.contentWindow.postMessage(
      {
        type: "MODULE_ID",
        module_id: payloadModuleIdandUserid,
        ...(payload ? { payload } : {}) // hanya kirim kalau ada
      },
      baseUrlOrigin
    );
  };

  const sendToken = () => {
    const iframe = document.getElementById(
      isMobileVersion ? "scorm-player-mobile" : "scorm-player"
    );
    const tokenUser = getAccessToken()

    console.log("send token")

    iframe.contentWindow.postMessage(
      {
        type: "TOKEN_WEB",
        token: tokenUser
      },
      baseUrlOrigin
    );
  }

  // untuk mengirim data yang telah difetch jika ada
  const updateDataToIframe = () => {
    const getScorm = sessionStorage.getItem("data-get-scorm")
    const payload = JSON.parse(getScorm)
    
    if (!payload || !Array.isArray(payload)) {
      console.warn("⚠️ payload harus berupa array of object");
      return;
    }

    const iframe = document.getElementById(
      isMobileVersion ? "scorm-player-mobile" : "scorm-player"
    );
    console.log("update_data")
    console.log(payload)
    iframe.contentWindow.postMessage(
      {
        type: "UPDATE_DATA",
        payload: payload
      },
      baseUrlOrigin
    );
    sessionStorage.removeItem("data-get-scorm");
  };

  const handShakeDeleteExit = () => {
    const urlNow = window.location.pathname;
    const arrIdNow = urlNow.split("/");
    
    handleDataScormSend(arrIdNow)
    const iframe = document.getElementById(
      isMobileVersion ? "scorm-player-mobile" : "scorm-player"
    );

    console.log("delete session data")

    iframe.contentWindow.postMessage(
      {
        type: "DELETE_SESSION"
      },
      baseUrlOrigin
    );
  }
  
  useEffect(() => {
  const handleMessage = (event) => {
    const urlNow = window.location.pathname;
    const arrIdNow = urlNow.split("/");
    
    // Pastikan hanya terima pesan dari origin iframe
    if (event.origin !== baseUrlOrigin) return;

    // Kalau pesan dari child ada tipe
    if (event.data?.type === "DONE_INIT") {
      // Panggil ketiga fungsi setelah child selesai init
      sendModuleIdtoIframe();
      sendToken();
      updateDataToIframe();
      return; // stop biar ga masuk ke setLocalStorage
    }
    if (event.data?.type === "DELETE_SESSION") {
      console.log("kehapus")
      
      return
    }

    // Default: simpan data ke localStorage
    const isItValid = isValidDataFromModule(event.data);

    if (isItValid === "not_valid_data") {
      // not valid data
    } else {
      setLocalStorage("scorm-" + arrIdNow[7], encryptData(event.data));
    }
  };

  window.addEventListener("message", handleMessage);

  return () => window.removeEventListener("message", handleMessage);
}, []);

  const isValidDataFromModule = (data) => {
    try {
        // 1️⃣ Cek apakah data bisa di-parse sebagai JSON
        const parsed = typeof data === "string" ? JSON.parse(data) : data;
        if (!parsed || typeof parsed !== "object") return "not_valid_data";

        // 2️⃣ Harus punya key 'data_scorm_web'
        if (parsed.key !== "data_scorm_web") return "not_valid_data";

        // 3️⃣ Cek apakah ada properti 'value' dan tidak null/kosong/undefined
        if (
          !("value" in parsed) ||
          parsed.value === null ||
          parsed.value === undefined ||
          parsed.value === "" ||
          parsed.value === "[]"
        ) {
          return "not_valid_data";
        }

        // 4️⃣ Coba parse value-nya
        let valueParsed;
        try {
          valueParsed =
            typeof parsed.value === "string"
              ? JSON.parse(parsed.value)
              : parsed.value;
        } catch {
          return "not_valid_data";
        }

        // 5️⃣ Pastikan valueParsed berbentuk array dan tidak kosong
        if (!Array.isArray(valueParsed) || valueParsed.length === 0) {
          return "not_valid_data";
        }

        // ✅ Semua valid
        return parsed;
      } catch {
        // JSON utama tidak bisa di-parse
        return "not_valid_data";
      }
  }

  useEffect(() => {
    // Cegah eksekusi di desktop jika kamu hanya ingin aktif di mobile
    // Hapus kondisi ini kalau ingin aktif di semua perangkat
    // if (!isMobileVersion) return;

    // ✅ Buat dua dummy state untuk menangani perbedaan browser
    if (!window.__PLAY_MODULE_PUSHED__) {
      window.history.pushState({ page: "dummy1" }, "", window.location.pathname);
      window.history.pushState({ page: "dummy2" }, "", window.location.pathname);
      window.__PLAY_MODULE_PUSHED__ = true;
    }

    const handlePopState = (event) => {
      event.preventDefault();

      // 🧠 Deteksi kalau state sebelumnya bukan milik kita
      if (!event.state || !event.state.page?.startsWith("dummy")) {
        // Kalau browser benar-benar ingin mundur ke luar module, tambahkan lagi dummy state
        window.history.pushState({ page: "dummyX" }, "", window.location.pathname);
        return;
      }

      // 🎯 Tampilkan modal custom
      quitModuleBack();

      // Dorong state baru agar posisi tetap di halaman ini
      window.history.pushState({ page: "dummy-keep" }, "", window.location.pathname);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      // 🧹 Bersihkan listener & flag global saat unmount
      window.removeEventListener("popstate", handlePopState);
      delete window.__PLAY_MODULE_PUSHED__;
    };
  }, []);
  
  const quitModuleBack = () => {
    if(isMobileVersion){
      setModalQuit(true);
      requestData();
    } else {
      setBackTrigger(true);
      setModalQuit(true);
      requestData();
    }
  }
  
  



  useEffect(() => {
    if(loadingSendScorm == false) handleExit();
  },[loadingSendScorm])

  return (
    <div
      style={
        isMobileVersion
          ? {
              ...styles.contentWrapperMobile,
              height: "100vh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }
          : styles.contentWrapper
      }
    >
      <Row
        style={
          isMobileVersion
            ? {
                ...styles.headWrapperMobile,
                height: 60,
                minHeight: 60,
                maxHeight: 60,
                flex: "0 0 60px",
                zIndex: 2,
                background: "#fff",
              }
            : styles.headWrapper
        }
      >
        {isMobileVersion ? (
          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            justify={"space-between"}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <ArrowLeftOutlined
                style={{ color: "#212121" }}
                onClick={(e) => {
                  e.preventDefault();
                  setModalQuit(true);
                  requestData();
                }}
              />
              <div style={{ fontSize: 16, fontWeight: 500, color: "#212121" }}>
                <span>{t("feature.feature_mylj.anchor.quit_module")}</span>
              </div>
            </div>
          </Row>
        ) : (
          <>
            <Col span={20} style={styles.moduleCountFullname}>
              <span style={styles.moduleCount}>
                {loadingFetchStream ? (
                  <Skeleton.Input
                    active
                    size={30}
                    style={{ minWidth: "100px" }}
                  />
                ) : (
                  <>
                    {t("feature.feature_mylj.stream_scorm.module_index")}{" "}
                    {idxOpenedModule !== undefined ? idxOpenedModule : idx}
                  </>
                )}
                {/* Module 1 */}
              </span>
              &nbsp;
              <span className="break-dots-first-line" style={styles.moduleFullname}>
                {loadingFetchStream ? (
                  <Skeleton.Input
                    active
                    size={30}
                    style={{ minWidth: "500px" }}
                  />
                ) : moduleStream !== undefined ? (
                  moduleStream.fullname
                ) : (
                  currModuleStream
                )}
                {/* Sales Rhytm */}
              </span>
            </Col>
            <Col span={4} style={styles.fullscreenWrapper}>
              <Button
                className="btn-fullscreen-stream"
                onClick={() => handleFullscreen()}
                style={styles.buttonFullscreenStyle}
              >
                <span style={styles.textFullscreen}>
                  {t("feature.feature_mylj.stream_scorm.full_screen")}
                </span>
                <ExpandOutlined style={styles.iconFullscreen} />
              </Button>
            </Col>
          </>
        )}
      </Row>
      <Row
        id="test-id"
        style={
          isMobileVersion ? styles.wrapperIframeMobile : styles.wrapperIframe
        }
      >
        {isModuleAttd !== undefined && isModuleAttd === 1 ? (
          <div
            id="attendance-wrapper"
            className="attendance-wrapper"
            style={{
              width: 1366,
              height: 768,
              backgroundImage: `url(${BGAttendance})`,
              display: "flex",
              justifyContent: "center",
              padding: "92px 0",
              alignItems: loadingFetchQR ? "center" : "center",
            }}
          >
            {loadingFetchQR ? (
              <>
                <div
                  style={{
                    width: 130,
                    height: 130,
                    background: "#FFFFFF",
                    borderRadius: 32,
                  }}
                >
                  <Image preview={false} src={loader} fallback={loader} />
                </div>
              </>
            ) : (
              <>
                <div style={{ maxWidth: 500 }}>
                  <div
                    className="qr-sect"
                    style={{
                      display:
                        dataWS === undefined && moduleStream.is_complete === 0
                          ? successPopup === false
                            ? "block"
                            : "none"
                          : "none",
                    }}
                  >
                    <div
                      className="qr-code-title"
                      style={{ textAlign: "center", marginBottom: 40 }}
                    >
                      <div
                        style={{
                          fontSize: 32,
                          color: "#AACEFF",
                          fontWeight: "bolder",
                          marginBottom: 12,
                        }}
                      >
                        Check-in
                      </div>
                      <div
                        className="break-dots-second-line"
                        style={{
                          fontSize: 24,
                          color: "#FFFFFF",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          fontWeight: "bolder",
                        }}
                      >
                        {classAttd}
                      </div>
                    </div>
                    <div
                      className="qr-code-attendace"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <div
                        className="qr-image"
                        style={{
                          padding: 25,
                          borderRadius: 24,
                          background: "#FFFFFF",
                        }}
                      >
                        <Image
                          preview={false}
                          width={250}
                          style={{}}
                          src={imgQRCodeAttd}
                          fallback={QRCodeDummy}
                        />
                      </div>
                    </div>
                    <div
                      className="info-detail"
                      style={{
                        width: 500,
                        background: "#FFFFFF",
                        borderRadius: 32,
                      }}
                    >
                      <div
                        className="qr-space-blue"
                        style={{
                          height: 144,
                          background: "#E4ECFE",
                          borderTopLeftRadius: 32,
                          borderTopRightRadius: 32,
                          marginTop: -124,
                        }}
                      ></div>
                      <div
                        style={{
                          padding: "32px 40px 40px 40px",
                        }}
                      >
                        <div
                          className="qr-desc"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          <span
                            className="break-dots-second-line"
                            style={{
                              fontSize: 24,
                              color: "#333333",
                              marginBottom: 16,
                              fontWeight: "bolder",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            Hai, {learnerNameAttd}
                          </span>
                          <span style={{ fontSize: 20, color: "#666666" }}>
                            Tunjukkan kode QR di atas.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="success-checkin-sect"
                    style={{
                      background: "#FFFFFF",
                      borderRadius: 32,
                      width: 500,
                      padding: 40,
                      display:
                        dataWS !== undefined
                          ? "block"
                          : successPopup
                          ? "block"
                          : "none",
                    }}
                  >
                    <div style={{ textAlign: "center", marginBottom: 32 }}>
                      <Image
                        preview={false}
                        width={82}
                        style={{ marginBottom: 24 }}
                        src={ic_check}
                      />
                      <div
                        style={{
                          fontSize: 32,
                          color: "#01AA90",
                          fontWeight: "bolder",
                        }}
                      >
                        Check-in Berhasil
                      </div>
                    </div>
                    <div style={{ textAlign: "center", marginBottom: 40 }}>
                      <div
                        className="break-dots-second-line"
                        style={{
                          fontSize: 24,
                          fontWeight: "bolder",
                          marginBottom: 24,
                          color: "#333333",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {dataWS !== undefined
                          ? dataWS.class
                          : dataCompleteAttendance !== undefined
                          ? dataCompleteAttendance.class
                          : ""}
                      </div>
                      <div>
                        <div style={{ marginBottom: 24 }}>
                          <div style={{ color: "#666666", fontSize: 20 }}>
                            Tanggal & Waktu Check-in
                          </div>
                          <div
                            style={{
                              fontSize: 20,
                              fontWeight: "bold",
                              color: "#333333",
                            }}
                          >
                            {dataWS !== undefined
                              ? dataWS.date
                              : dataCompleteAttendance !== undefined
                              ? moment(dataCompleteAttendance.date).format(
                                  "DD MMMM YYYY, h:mm",
                                )
                              : ""}
                          </div>
                        </div>
                        <div>
                          <div style={{ color: "#666666", fontSize: 20 }}>
                            Lokasi Check-in
                          </div>
                          <div
                            className="break-dots-second-line"
                            style={{
                              fontSize: 20,
                              fontWeight: "bold",
                              color: "#333333",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {dataWS !== undefined
                              ? dataWS.is_offline === 1
                                ? dataWS.location
                                : dataWS.location_online
                              : dataCompleteAttendance !== undefined
                              ? dataCompleteAttendance.is_offline === 1
                                ? dataCompleteAttendance.location
                                : dataCompleteAttendance.location_online
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: 20,
                        color: "#001489",
                        background: "#E4ECFE",
                        borderRadius: 16,
                        padding: 20,
                        textAlign: "center",
                      }}
                    >
                      Mulai pembelajaran Anda dengan klik modul berikutnya.
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        ) : isMobileVersion ? (
          loadingFetchStream || loadingCheckCompleteModule ? (
            <div
                className="loader-stream"
                style={{
                  display:"flex",
                  border:"unset",
                  width:"100%",
                  height:"100%",
                  alignItems:"center",
                  justifyContent:"center",
                  fontSize:20
              }}>
                <div className="loader-spin"></div>
                Preparing module…
              </div>
          ) : (
            <>
              <div
                className="loader-stream"
                style={{
                  display:iframeOnload ? "flex" : "none",
                  border:"unset",
                  width:"100%",
                  height:"100%",
                  alignItems:"center",
                  justifyContent:"center",
                  fontSize:20
              }}>
                <div className="loader-spin"></div>
                Preparing module…
              </div>

              <iframe
                id={"scorm-player-mobile"}
                src={linkStream !== undefined ? linkStream : currModuleLink}
                width="100%"
                height={"100%"}
                style={{
                  display:iframeOnload ? "none" : "block",
                  border: "none",
                  height: "100%",
                  width: "100%",
                  minHeight: "calc(100vh - 60px)",
                  maxHeight: "calc(100vh - 60px)",
                  overflow: "hidden",
                  flex: 1,
                }}
                allow="camera; microphone"
                onLoad={handleIframeLoad}
                ref={iframeRef}
              />
            </>
          )
        ) :
        
            <>
              <div
                className="loader-stream"
                style={{
                  display:iframeOnload ? "flex" : "none",
                  width: "50.5vw",
                  height: "auto",
                  aspectRatio: "4/3",
                  maxHeight:"76vh",
                  maxWidth:"calc(76vh * (4 / 3))",
                  justifyContent:"center",
                  alignItems:"center",
                  fontSize:20
              }}>
                <div className="loader-spin"></div>
                Preparing module…
              </div>
              
              <iframe
                id={"scorm-player"}
                src={linkStream !== undefined ? linkStream : currModuleLink}
                allow="camera; microphone"
                style={{
                  display:iframeOnload ? "none" : "block",
                  width: "50.5vw",
                  height: "auto",
                  aspectRatio: "4/3",
                  maxHeight:"76vh",
                  maxWidth:"calc(76vh * (4 / 3))"
                }}
                onLoad={handleIframeLoad}
                ref={iframeRef}
              />
            </>}

        {/* <div>
          <h1>WebSocket with Reconnect</h1>
          <ul>
            {messages.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          <button onClick={sendMessage}>Send</button>
        </div> */}
      </Row>

      <ModalQuitScorm
        openModalQuit={openModalQuit}
        setModalQuit={setModalQuit}
        setCheckModalQuit={setCheckModalQuit}
        setConfirmNavigate={setConfirmNavigate}
        setListCourseBlocker={setListCourseBlocker}
        setCourseIdClicked={setCourseIdClicked}
        handleExit={handleExit}
        handleNo={handleNo}
        isMobileVersion={isMobileVersion}
        handShakeDeleteExit={handShakeDeleteExit}
      />
    </div>
  );
};

export default StreamSCORM;
